var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('AQuillEditor',{ref:"myQuillEditor",model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_c('mi-button',{attrs:{"icon":"save"},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$tc('actions.save', 1)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }